import React from "react";
import ReactDOM from "react-dom";
import XilentApplication from "./XilentApplication";
import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
  <BrowserRouter>
    <XilentApplication />
  </BrowserRouter>,
  document.getElementById("root")
);
